import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';

import { useSettings } from '../../context/SettingsContext'
import { Nav } from '../partials/Nav';
import { API_URL } from '../Constants';

const Validators = () => {
  const settings = useSettings();
  const [validators, setValidators] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Validators | ValParx Admin'
    let token = settings.userToken;

    if (token) {
      fetchValidators(token);
    }
  }, [settings.userToken]);

  const fetchValidators = (token) => {
    setLoading(true);
    setError('');

    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", token);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(API_URL + "admin_validatorgetall", requestOptions)
      .then(response => response.json())
      .then(result => {
        setLoading(false);
        if (result.success) {
          setValidators(result.validators || []);
        } else {
          setError(result.error || 'Failed to load validators');
          setValidators([]);
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoading(false);
        setError('An error occurred while fetching validators');
        setValidators([]);
      });
  };

  const getApprovalStatus = (approved) => {
    return approved === "1" || approved === 1 ? (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Approved
      </span>
    ) : (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
        Pending
      </span>
    );
  };

  return (
    <div className='min-h-screen flex items-start justify-center py-12 px-4 sm:px-6 lg:px-8'>
      <Nav />
      <div className="max-w-6xl w-full space-y-8 pt-20">
        <div className='flex justify-between items-center mb-12'>
          <h2 className='mb-0'>Validator Management</h2>
        </div>

        {error && (
          <div className='bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4'>
            {error}
          </div>
        )}

        {loading ? (
          <p className='text-blueGray-500 items-center flex text-center justify-center'>
            <span>Loading Validators...</span>
            <FontAwesomeIcon icon="fa-solid fa-spinner" className='text-sm ml-2 fa-spin' />
          </p>
        ) : validators && validators.length > 0 ? (
          <div className="overflow-x-auto shadow-md rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Name
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Company
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {validators.map((validator) => (
                  <tr key={validator.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">{validator.name}</div>
                      <div className="text-sm text-gray-500">{validator.email}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{validator.company}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getApprovalStatus(validator.approved)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <Link
                        to={`/validator/${validator.id}`}
                        className="text-accent hover:text-blue-900 inline-flex items-center"
                      >
                        View Details
                        <FontAwesomeIcon icon="fa-arrow-right fa-solid" className='ml-2 text-xs' />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className='text-center font-medium py-8'>No validators found in the system.</p>
        )}
      </div>
    </div>
  )
}

export default Validators
